import axios from "axios";
import * as devConfig from "../../../config/myConfig";

import {MSG_MODES, MSG_TYPES, setMessage} from "../../libs/message";
import {
  BASER_SERVER_ERROR_CODE_WITH_ERROR_MESSAGE, COMMON_SERVER_ERROR_CODES,
  COMMON_SERVER_ERROR_MESSAGE, DURATION_OF_SERVER_ERROR_MESSAGE, WHITE_LIST_CODE
} from "../../config/app";
import ArrayUtils from "../../libs/utils/ArrayUtils";
import UserPersistence from "../../persistence/UserPersistence";
import {ExitOut} from "../../libs/comFun/exitOut";
import CustomLoading from "./helper"
const CONSOLE_COLOR = 'background: #4368aa;color: #FFFFFF';
const CONSOLE_COLOR_ERROR = 'background: #e83838;color: #FFFFFF';
const ENABLE_DEBUG = devConfig.ENABLE_API_LOG === undefined ?
  process.env.NODE_ENV !== 'production' : devConfig.ENABLE_API_LOG;

  // 创建加载页对象
const customLoadingObj = new CustomLoading();
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
});
let flag = true;

service.interceptors.response.use((response) => {
  customLoadingObj.tryHideFullScreenLoading();
  printResponse(response);

  if(response.config.method === 'options') return;// 如果是预检请求直接返回

  let data = response.data;
  //服务器返回错误消息
  if (data.error) {
    handleResponseError(data.error);
  }
  return response.data;
}, function (error) {
  customLoadingObj.tryHideFullScreenLoading();
  handleNetworkError(error);
  return {result : false, value: false}
});

service.interceptors.request.use(config => {
  customLoadingObj.showFullScreenLoading();
  // 教育环境对接请求根据questionId获取数据
  if(config.url.indexOf('api-resource') > -1){
    const sourceCode = UserPersistence.getBaseInfo().user.encrypted || ''
    if (UserPersistence.getBaseInfo().user.openType === 'zlpx') {
      config.baseURL = process.env.ZLPX_API
      config.url = config.url.replace('api-resource', 'api-res')
    } else {
      config.baseURL = process.env.EDU_API
    }
    if (!sourceCode.startsWith('MATCH_') && process.env.MODE === 'ds-pro') {
      config.baseURL = process.env.EDU_API_SX
    }
  }
  // if (process.env.NODE_ENV === 'development') {
  //   config.headers.authorization = 'bearer ' + 'e06ece13-b2e6-4ce1-b57c-96970b2abbda';
    // config.headers.authorization = 'bearer ' + 'add51a19-efd8-46f1-bd3b-2575071fe05d';
  // } else {
    config.headers.authorization = 'bearer ' + UserPersistence.getToken();
  // }
  return config;
});


function printResponse(response) {

  if (ENABLE_DEBUG) {
    let hasError = response.data.error;
    if (hasError) {
      console.log("%c Http ", CONSOLE_COLOR_ERROR, "<- URL: " + response.config.url + "\n       <- error:", response.data.error);
    } else {
      console.log("%c Http ", CONSOLE_COLOR, "<- URL: " + response.config.url + "\n       <- data:", response.data);
    }
  }
}

function handleResponseError(error) {
  let errorCode = error.code,
    errorMessage = null;

  if (errorCode && ArrayUtils.oneOf(errorCode, COMMON_SERVER_ERROR_CODES)) {
    errorMessage = COMMON_SERVER_ERROR_MESSAGE;
  } else if (parseInt(errorCode) === 40001 || parseInt(errorCode) === 40002) {//token过期，清空缓存数据，重新登录
    if (!flag) return;
    flag = false;
    let flagTimer = setTimeout(() => {flag = true; clearTimeout(flagTimer)},5000);
    setMessage({
      type: MSG_TYPES.WARNING,
      mode: MSG_MODES.MESSAGE_BOX,
      title: "提示",
      message: error.message,
      onOk: () => {
        ExitOut()
      },
      onCancel: () => {
        ExitOut()
      }
    });
    return;
  } else if (errorCode > BASER_SERVER_ERROR_CODE_WITH_ERROR_MESSAGE || errorCode>DURATION_OF_SERVER_ERROR_MESSAGE) {
    errorMessage = error.message;
  }

  if (errorCode && ArrayUtils.oneOf(errorCode, WHITE_LIST_CODE)) return;

  if(!errorMessage) return;

  setMessage({
    type: MSG_TYPES.ERROR,
    mode: MSG_MODES.MESSAGE,
    duration: DURATION_OF_SERVER_ERROR_MESSAGE,
    message: errorMessage
  });

}



function handleResponseInfo(data) {
  let info = data.msg;

  setMessage({
    type: MSG_TYPES.INFO,
    mode: MSG_MODES.MESSAGE,
    duration: DURATION_OF_SERVER_ERROR_MESSAGE,
    message: info
  });
}


function isResponseEmpty(data) {
  return !data.value && data.value !== '' && data.value !== false && data.value !== 0;
}

function handleEmptyResponse() {
  setMessage({
    type: MSG_TYPES.ERROR,
    mode: MSG_MODES.MESSAGE,
    duration: DURATION_OF_SERVER_ERROR_MESSAGE,
    message: "没有返回值"
  });
}

function handleNetworkError(error) {
  console.error(error);
  setMessage({
    type: MSG_TYPES.ERROR,
    mode: MSG_MODES.MESSAGE,
    duration: DURATION_OF_SERVER_ERROR_MESSAGE,
    message: COMMON_SERVER_ERROR_MESSAGE
  })
}

export default service;



// WEBPACK FOOTER //
// ./src/api/Http/request.js